import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ActiveItemActions } from "../../../../../../../store/ActiveItem/ActiveItemActions";
import { Tables, SelectComponet } from "../../../../../../../Components";
import { TableActions } from "../../../../../../../Enums";
import { GetParams, GlobalHistory } from "../../../../../../../Helper";
import { PSIClubReferralsTableHeaderData } from "./PSIClubReferralsTableHeaderData";
import { LeadStatusEnum } from "../../../../../../../Enums";

export const ContactProfilePSIClubReferrals = ({
  leadsDetailes,
  translationPath,
  parentTranslationPath,
  filter,
  setFilter,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const dispatch = useDispatch();
  const [list, setList] = useState([
    {
      enum: TableActions.openFile.key,
    },
  ]);
  const [activeItem, setActiveItem] = useState(null);

  const reducer = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };
  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));
  };

  const tableActionClicked = useCallback((actionEnum, item) => {
    setActiveItem(item);
    if (actionEnum === TableActions.openFile.key) {
      dispatch(ActiveItemActions.activeItemRequest(item));
      const leadClass =
        item.leadType === "Seeker" || item.leadType === "seeker" ? 2 : 1;
      window.open(
        `/home/leads/lead-profile-edit?formType=${leadClass}&id=${item.leadId}`,
        "_blank"
      );
    }
  }, []);

  return (
    <div className="w-100 my-4 mt-2 mb-2 d-flex-column">
      <div className="d-flex-inline d-flex-v-centter-h-start">
        <div className="filter-section-item d-flex-h-start w-25">
          <span className="fw-simi-bold">{t(`${translationPath}status`)}:</span>
          <SelectComponet
            idRef="leadStatus"
            data={Object.values(LeadStatusEnum)}
            value={filter?.leadStatus}
            onSelectChanged={(newValue) => {
              setFilter((f) => ({ ...f, leadStatus: newValue }));
            }}
            wrapperClasses="mx-2"
            themeClass="theme-transparent"
            valueInput="key"
            textInput="value"
            emptyItem={{ value: null, text: "all", isDisabled: false }}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            translationPathForData={translationPath}
          />
        </div>
      </div>
      <Tables
        data={leadsDetailes ? leadsDetailes.result : []}
        headerData={PSIClubReferralsTableHeaderData(
          parentTranslationPath,
          translationPath
        )}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
        defaultActions={list || []}
        actionsOptions={{
          onActionClicked: tableActionClicked,
        }}
        itemsPerPage={filter.pageSize}
        activePage={filter.pageIndex}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        totalItems={
          leadsDetailes && leadsDetailes.totalCount
            ? leadsDetailes.totalCount
            : 0
        }
      />
    </div>
  );
};
